/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../../shared/types/__generated__/graphql"
import { SpecialPriceGroupFragmentDoc } from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

const defaultOptions = {} as const
export type CreateSpecialPriceGroupInput = {
  id: string
  parentPriceGroup?: string | null
  productType: string
}

export type CreateSpecialPriceGroupMutationVariables = Exact<{
  projectID: string
  input: Types.CreateSpecialPriceGroupInput
}>

export type CreateSpecialPriceGroupMutation = {
  __typename: "Mutation"
  specialPriceGroup: {
    __typename: "SpecialPriceGroup"
    id: string
    name: string
    parentPriceGroup?: string | null
    productType: string
  }
}

export type DeleteSpecialPriceGroupMutationVariables = Exact<{
  id: string
  projectID: string
}>

export type DeleteSpecialPriceGroupMutation = {
  __typename: "Mutation"
  specialPriceGroup: { __typename: "DeleteResponse"; success: boolean }
}

export const CreateSpecialPriceGroupDocument = gql`
  mutation CreateSpecialPriceGroup(
    $projectID: ID!
    $input: CreateSpecialPriceGroupInput!
  ) {
    specialPriceGroup: createSpecialPriceGroup(
      projectID: $projectID
      input: $input
    )
      @rest(
        type: "SpecialPriceGroup"
        method: "POST"
        path: "/project-list/projects/{args.projectID}/special-price-groups"
        bodySerializer: "specialPriceGroup"
      ) {
      ...SpecialPriceGroup
    }
  }
  ${SpecialPriceGroupFragmentDoc}
`
export type CreateSpecialPriceGroupMutationFn = Apollo.MutationFunction<
  CreateSpecialPriceGroupMutation,
  CreateSpecialPriceGroupMutationVariables
>

/**
 * __useCreateSpecialPriceGroupMutation__
 *
 * To run a mutation, you first call `useCreateSpecialPriceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpecialPriceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpecialPriceGroupMutation, { data, loading, error }] = useCreateSpecialPriceGroupMutation({
 *   variables: {
 *      projectID: // value for 'projectID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSpecialPriceGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSpecialPriceGroupMutation,
    CreateSpecialPriceGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateSpecialPriceGroupMutation,
    CreateSpecialPriceGroupMutationVariables
  >(CreateSpecialPriceGroupDocument, options)
}
export type CreateSpecialPriceGroupMutationHookResult = ReturnType<
  typeof useCreateSpecialPriceGroupMutation
>
export type CreateSpecialPriceGroupMutationResult =
  Apollo.MutationResult<CreateSpecialPriceGroupMutation>
export type CreateSpecialPriceGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateSpecialPriceGroupMutation,
  CreateSpecialPriceGroupMutationVariables
>
export const DeleteSpecialPriceGroupDocument = gql`
  mutation DeleteSpecialPriceGroup($id: ID!, $projectID: ID!) {
    specialPriceGroup: deleteSpecialPriceGroup(id: $id, projectID: $projectID)
      @rest(
        type: "DeleteResponse"
        method: "DELETE"
        endpoint: "delete"
        path: "/project-list/projects/{args.projectID}/special-price-groups/{args.id}"
      ) {
      success
    }
  }
`
export type DeleteSpecialPriceGroupMutationFn = Apollo.MutationFunction<
  DeleteSpecialPriceGroupMutation,
  DeleteSpecialPriceGroupMutationVariables
>

/**
 * __useDeleteSpecialPriceGroupMutation__
 *
 * To run a mutation, you first call `useDeleteSpecialPriceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSpecialPriceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSpecialPriceGroupMutation, { data, loading, error }] = useDeleteSpecialPriceGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      projectID: // value for 'projectID'
 *   },
 * });
 */
export function useDeleteSpecialPriceGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSpecialPriceGroupMutation,
    DeleteSpecialPriceGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteSpecialPriceGroupMutation,
    DeleteSpecialPriceGroupMutationVariables
  >(DeleteSpecialPriceGroupDocument, options)
}
export type DeleteSpecialPriceGroupMutationHookResult = ReturnType<
  typeof useDeleteSpecialPriceGroupMutation
>
export type DeleteSpecialPriceGroupMutationResult =
  Apollo.MutationResult<DeleteSpecialPriceGroupMutation>
export type DeleteSpecialPriceGroupMutationOptions = Apollo.BaseMutationOptions<
  DeleteSpecialPriceGroupMutation,
  DeleteSpecialPriceGroupMutationVariables
>
